export default __webpack_public_path__ + "static/media/Invigorating Shoulders.cac7f25f.jpg";